





































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import {DashboardAdmin} from '@/router/pages'
import axios from 'axios'
import FileDownload from 'js-file-download'

@Component({
  name: 'GestionCommande'  
})
export default class GestionCommande extends Vue {
  private loading = false
  private showError = false    
  private actioning = false
  private newCommande = getDefaultAloCommande()
  private defaultHeaderHeight = 90
  mounted() {
    this.defaultHeaderHeight = 5
  }  

  get tableauHeight(){
    //@ts-ignore
    return this.$store.myGetters.contentHeight - ((this.$refs?.header?.clientHeight+this.defaultHeaderHeight)??this.defaultHeaderHeight)
  }

  private get isAllSelected() {
    return this.commandeList.every(p => p.selected)
  }

  private get someSelected() {
    return this.commandeList.some(p => p.selected)
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  private get total(){
    return this.cmdPayantes.reduce((total,item)=>{return total + item.cmdTotal! },0)
  }

  private get cmdPayantes(){
    return this.commandeList.filter(it => it.cmdTotal! > 0)
  }

  private get panierMoyen(){
    return this.total / Math.max(this.cmdPayantes.length,1)
  }

  

  private headers = [        
    { text: 'Id', value: 'id', width:70},       
    { text: 'Date', value: 'cmdDatvalidation', width:160  },
    { text: 'Status', value: 'cmdStatus', width:160  },       
    { text: 'Famille', value: 'libelle'},       
    { text: 'Ville', value: 'address.libelle' },
    { text: 'Total', value: 'cmdTotal', width:200, align:'end' }
  ]

  private get commandeMinDate(){
    return this.$store.myGetters.commandeMinDate 
  } 

  private get selectedMonth(){ 
    return this.$store.myGetters.monthCommande
  }

  private set selectedMonth(newMonth){
    this.$store.myActions.UI_SET_MONTH_COMMANDE(newMonth.toUTCString())
  }

  private get selectedPeriode() {    
    //@ts-ignore
    return this.selectedMonth.getUTCDate() == 31?this.$options.filters.formatDate(this.selectedMonth,"YYYY"):this.$options.filters.formatDate(this.selectedMonth,"MMMM YYYY")
  }  
  
  private get commandeList() {
    return this.$store.myGetters.commandeList
  }

  private get search(){
    return this.$store.myGetters.searchCommande
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_COMMANDE(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortCommandeDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_COMMANDE_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortCommandeBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_COMMANDE_BY(value)
  }

    
  created() {
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
    this.$store.myActions.ADM_COMMANDE_MIN_DATE_ENSURE()      
  }

  loadCommandes(dates:Array<Date>){
    this.loading = true    
    this.$store.myActions.UI_SET_RIGHT_DRAWER_OPEN(false)
    setTimeout(() => {
      this.$store.myActions.ADM_COMMANDE_REQUEST(dates).finally(() => {        
        this.loading = false
      })
    }, 
    //@ts-ignore
    this.$vuetify.breakpoint.mobile?200:0);    
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyCommande',params:{commandeId:item.id}})    
  }

  deleteCommande(commande:AloCommande) {
     if(commande.id != 0) {      
       this.$confirm(`Voulez vous vraiment supprimer la commande "${commande.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_COMMANDE_DELETE_REQUEST(commande.id)
        } 
      })          
    } 
  }


  
  get arianeItems() {
    return  [
        DashboardAdmin,
        {
          text: 'Commandes',
          disabled: true,  
          to: {name:'AdminCommande'},        
          exact:true
        }
      ]      
  } 
 
}
